import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class WindowService {
  private windows: { [name: string]: Window } = {};

  constructor() { }

  open(url: string, name: string, features?: string): Window | null {
    // Close existing window if it's already open
    this.close(name);

    // Open a new window with the complete URL
    const windowRef = window.open(url, name, features || 'width=800,height=700');
    
    if (windowRef) {
      this.windows[name] = windowRef;
      
      // Remove from our list when the window is closed
      windowRef.onbeforeunload = () => {
        delete this.windows[name];
      };
    }
    
    return windowRef;
  }

  close(name: string): void {
    if (this.windows[name] && !this.windows[name].closed) {
      this.windows[name].close();
      delete this.windows[name];
    }
  }

  closeAll(): void {
    Object.keys(this.windows).forEach(name => {
      this.close(name);
    });
  }
}
